// react
import { useMemo } from 'react';
import styled from 'styled-components';

// assets
// @transform-path ../../../../../../src/assets/logo/logo-text-dark.svg
import logoTextDark from '@/assets/logo/logo-text-dark.svg';
// @transform-path ../../../../../../src/assets/logo/logo-text-light.svg
import logoTextLight from '@/assets/logo/logo-text-light.svg';
// @transform-path ../../../../../../src/assets/logo/logo-text-white.svg
import logoTextWhite from '@/assets/logo/logo-text-white.svg';
// @transform-path ../../../../../../src/assets/logo/logo-symbol-dark.svg
import logoSymbolDark from '@/assets/logo/logo-symbol-dark.svg';
// @transform-path ../../../../../../src/assets/logo/logo-symbol-light.svg
import logoSymbolLight from '@/assets/logo/logo-symbol-light.svg';
// @transform-path ../../../../../../src/assets/logo/logo-symbol-light.svg
import logoSymbolWhite from '@/assets/logo/logo-symbol-white.svg';

/**
 * Logo displays the KareHero logo.
 */
export const Logo = ({
  size = 'md',
  variant = 'text',
  color = 'dark',
}: LogoProps) => {
  // memos
  const symbolSrc = useMemo(() => {
    switch (color) {
      case 'light':
        return logoSymbolLight;
      case 'white':
        return logoSymbolWhite;
      default:
        return logoSymbolDark;
    }
  }, [color]);

  const textSrc = useMemo(() => {
    switch (color) {
      case 'light':
        return logoTextLight;
      case 'white':
        return logoTextWhite;
      default:
        return logoTextDark;
    }
  }, [color]);

  return (
    <StyledLogo size={size}>
      {(variant === 'symbol' || variant === 'full') && (
        <img src={symbolSrc} alt='logo symbol' />
      )}
      {(variant === 'text' || variant === 'full') && (
        <img src={textSrc} alt='logo text' />
      )}
    </StyledLogo>
  );
};

interface StyledLogoProps {
  size?: LogoSize;
}

const StyledLogo = styled.div<StyledLogoProps>`
  display: flex;
  gap: ${(props) => props.theme.spacing[8]};
  & > img {
    object-fit: contain;
    ${(props) => {
      switch (props.size) {
        case 'sm':
          return `
            min-height: 16px;
            max-height: 16px;
          `;
        case 'md':
          return `
            min-height: 23px;
            max-height: 23px;
          `;
        case 'lg':
          return `
            min-height: 36px;
            max-height: 36px;
          `;
        case 'xl':
          return `
            min-height: 48px;
            max-height: 48px;
          `;
        case 'fill':
          return `
            width: 100%;
          `;
      }
    }};
  }
`;

type LogoSize = 'sm' | 'md' | 'lg' | 'xl' | 'fill';
type LogoVariant = 'full' | 'symbol' | 'text';
type LogoColor = 'dark' | 'light' | 'white';

interface LogoProps {
  size?: LogoSize;
  variant?: LogoVariant;
  color?: LogoColor;
}

Logo.displayName = 'Logo';

export default Logo;
